import { useRef } from 'react';
import { Modal } from './Modal';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  onConfirm: () => void;
  onCancel: () => void;
}

// The confirm button takes focus on open, so Enter confirms and Escape cancels
// without a document-wide key listener — which used to confirm on Enter even
// when Cancel had focus.
export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const confirmButtonRef = useRef<HTMLButtonElement>(null);

  const confirmButtonClass = {
    danger: 'btn-error',
    warning: 'btn-warning',
    info: 'btn-info',
  }[variant];

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} description={message} initialFocusRef={confirmButtonRef}>
      <div className="modal-action">
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          {cancelText}
        </button>
        <button type="button" ref={confirmButtonRef} className={`btn ${confirmButtonClass}`} onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
}
